import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  user: {},
  error: "",
  isAuth: JSON.parse(localStorage.getItem("authState"))?.isAuth
    ? JSON.parse(localStorage.getItem("authState")).isAuth
    : false,
  staffs: [],
}

const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUserPending: (state) => {
      state.isLoading = true
    },
    getUserSuccess: (state, { payload }) => {
      state.isLoading = false
      state.isAuth = true
      state.user = payload
      state.error = ""
    },
    loginSuccess: (state, { payload }) => {
      state.isLoading = false
      state.isAuth = true
    },
    logOutSuccess: (state) => {
      state.isLoading = false
      state.user = {}
      state.isAuth = false
    },
    loginAuto: (state) => {
      state.isLoading = false
      state.isAuth = true
    },
    getAllAdminSuccess: (state, { payload }) => {
      state.isLoading = false
      state.staffs = payload
    },
    getUserFail: (state, { payload }) => {
      state.isLoading = false
      state.error = payload
    },
  },
})

const { reducer, actions } = UserSlice
export const {
  getUserPending,
  getUserSuccess,
  getUserFail,
  loginSuccess,
  getAllAdminSuccess,
  logOutSuccess,
  loginAuto,
} = actions

export default reducer
